import { Button } from '@components/core-ui/form-elements/buttons/Button/';
import { OutlinedButton } from '@components/core-ui/form-elements/buttons/Button/variations/OutlinedButton';
import { Input } from '@components/core-ui/form-elements/Input';
import { AbsoluteSpinner } from '@components/core-ui/spinners/Spinner/variations/AbsoluteSpinner';
import { ModalTitle } from '@modals/core-ui/ModalTitle';
import { ModalWrapper } from '@modals/core-ui/ModalWrapper';
import { useAPI } from '@providers/useAPI';
import { useMutation } from '@tanstack/react-query';
import { JobsAdminService } from 'app/API';
import { notifyApiCallError } from 'app/http/notifyApiCallError';
import { useState } from 'react';
import toast from 'react-hot-toast';
import { TProps } from './types/TProps';

export const MarkJobReportedModal = ({ id, onCancel, onSuccess }: TProps) => {
  const { call } = useAPI();
  const [description, setDescription] = useState('');
  const [summary, setSummary] = useState('');

  const reportMutation = useMutation({
    mutationFn: () =>
      call(() => JobsAdminService.markJobAsReportedByAdmin({ jobId: id, requestBody: { description, summary } })),
    onSuccess: () => {
      toast.success('Job was reported successfully!');
      onSuccess();
    },
    onError: notifyApiCallError,
  });

  const isLoading = reportMutation.isPending;
  const isSubmitDisabled = isLoading || !summary.trim() || !description.trim();

  return (
    <ModalWrapper width="400px" onCancel={onCancel}>
      {isLoading ? <AbsoluteSpinner overlay={true} /> : null}

      <ModalTitle>Create Jira task and report the job</ModalTitle>

      <div className="flex flex-col gap-5">
        <Input
          required
          label="Summary"
          placeholder="Short one-line title for the Jira task"
          value={summary}
          onChange={(event) => setSummary(event.target.value)}
        />

        <Input
          multiline
          required
          label="Description"
          placeholder="What went wrong, and what you already checked"
          value={description}
          onChange={(event) => setDescription(event.target.value)}
        />
      </div>

      <div className="flex justify-end gap-2.5">
        <OutlinedButton onClick={onCancel}>Cancel</OutlinedButton>
        <Button onClick={() => reportMutation.mutate()} disabled={isSubmitDisabled}>
          Create task
        </Button>
      </div>
    </ModalWrapper>
  );
};
